import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

export interface UpdatePlusOneConfigResult {
  updatePlusOneConfig: {
    ok: boolean;
  };
}

export interface UpdatePlusOneConfigVariables {
  input: {
    eventId: number;
    allowPlusOnes: boolean;
    maxPlusOnes: number;
    collectQuestionnaireResponses: boolean;
    sendEmailNotification?: boolean;
    sendSlackNotification?: boolean;
  };
}

const UpdatePlusOneConfigMutation = gql`
  mutation UpdatePlusOneConfig($input: UpdatePlusOneConfigInputType!) {
    updatePlusOneConfig(input: $input) {
      ok
    }
  }
`;

export const updatePlusOneConfig = (
  variables: UpdatePlusOneConfigVariables
): Promise<UpdatePlusOneConfigResult> => {
  return gqlClient.request<UpdatePlusOneConfigResult>(UpdatePlusOneConfigMutation, variables);
};
